export default __webpack_public_path__ + "static/komplett-bank-f30a65d99d34e572de37845d9ded19af.png";